<template>
<div>
    <StepManager :steps="steps" v-if="hasStepManager == true"></StepManager>
    <div class="container-fluid">

        <Wizard :steps="steps" :tags="tags"></Wizard>

    </div>
</div>
</template>

<script>
//Form Component
import StepManager from '@/components/Form/StepManager.vue'
import Wizard from '@/components/Form/Wizard.vue'

//Services
import {
    APIService
} from '@/service/APIService.js'

export default {
    name: 'MainForm',
    components: {
        StepManager,
        Wizard
    },
    data: function () {
        return {
            hasStepManager: this.$store.state.showStepmanager,
            steps: {},
            tags: [],
            allTags: {},
            formId: this.$store.state.formId
        }
    },
    created() {
        var that = this;

        APIService.setEndpoints(this.$store.state.vueAppBackendUrl, this.$store.state.vueAppModernApiUrl);

        APIService.getTags(function (response) {
            that.allTags = response;

            APIService.getSteps(that.formId, function (response) {
                that.steps = response;

                APIService.getForms(that.formId, function (response) {
                    var formTags = response.tags;

                    for (var i = 0; i < formTags.length; i++) {
                        for (var j = 0; j < that.allTags.length; j++) {
                            if(formTags[i].id === that.allTags[j].id){
                                that.tags.push(that.allTags[j])
                            }
                        }
                    }

                    that.hideLoader();
                });

            });

        });
    },
    methods: {
        hideLoader: function () {
            var loader = document.getElementById('wizard-loading');
            if (loader)
                document.getElementById('wizard-loading').style.display = "none";
        }
    }
}
</script>
